import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';

import withErrorContainer from '@zr/components/withErrorContainer';
import { NAME, PHONE_NUMBER } from '@zr/utilities/profileFields';

import FullNameField from '@zr/components/Fields/Formik/FullNameField';
import PhoneNumberField from '@zr/components/Fields/Formik/PhoneNumberField';

import {
  STRING_SCREEN_APPLY_NOW,
  STRING_SCREEN_CONTINUE,
} from '@zr/jobseeker-public/apps/jobseeker-screens/labels';

import {
  STRING_FIELD_PHONE_NUMBER_REQUIRED,
} from '@zr/components/Fields/labels';

import handleUpdateProfileFormikSubmit from '@zr/jobseeker-public/apps/profile-form/utilities/handleUpdateProfileFormikSubmit';

import { contactPropTypes } from '@zr/jobseeker-public/apps/jobseeker-screens/components/screenTypeSchema';
import { FirstNameLastNameValidation } from '@jobseeker/public/apps/jobseeker-screens/validation';
import { combineStrings } from './utilities';

import './ScreenViewWrapper.less';

const defaultStrings = {
  title: STRING_SCREEN_APPLY_NOW,
  cta: STRING_SCREEN_CONTINUE,
};

const validationSchema = Yup.object({
  [NAME]: FirstNameLastNameValidation,
  [PHONE_NUMBER]: Yup.string().trim().required(STRING_FIELD_PHONE_NUMBER_REQUIRED),
});

export function Contact({
  disabled, method, onContinue, onError, onErrorClose, initialContact, setIsLoading, strings,
}) {
  const labels = useMemo(() => combineStrings(strings, defaultStrings), [strings]);

  const handleFormSubmit = handleUpdateProfileFormikSubmit({
    method, onError, onStart: onErrorClose, onSuccess: onContinue, setIsLoading,
  });

  return (
    <Formik
      initialValues={initialContact}
      onSubmit={handleFormSubmit}
      validationSchema={validationSchema}
    >
      {(formikProps) => {
        const {
          handleSubmit, isSubmitting,
        } = formikProps;

        return (
          <form className="ScreenViewWrapper Contact" onSubmit={handleSubmit}>
            <fieldset disabled={disabled}>
              <legend className="title">{labels.title}</legend>
              <FullNameField
                name={NAME}
                formikProps={formikProps}
              />
              <PhoneNumberField
                name={PHONE_NUMBER}
                formikProps={formikProps}
              />
              <div className="button_wrapper">
                <button
                  className="primary_button"
                  disabled={isSubmitting || disabled}
                  type="submit"
                >
                  {labels.cta}
                </button>
              </div>
            </fieldset>
          </form>
        );
      }}
    </Formik>
  );
}

Contact.propTypes = {
  disabled: PropTypes.bool,
  method: PropTypes.string,
  onContinue: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onErrorClose: PropTypes.func.isRequired,
  initialContact: contactPropTypes.isRequired,
  setIsLoading: PropTypes.func,
  strings: PropTypes.object,
};

Contact.defaultProps = {
  disabled: false,
  method: null,
  setIsLoading: () => {},
  strings: undefined,
};

export default withErrorContainer(Contact);
